import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const RedoclyAPIBlock = makeShortcode("RedoclyAPIBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <InlineAlert variant="warning" slots="header, text" mdxType="InlineAlert"></InlineAlert>
    <p>{`Important`}</p>
    <p>{`The content on this page is provided for information purposes only. Usage of this API requires a current license from Adobe. No unauthorized use is permitted.`}</p>
    <RedoclyAPIBlock src="/adobe-pass/dcrApi.json" mdxType="RedoclyAPIBlock"></RedoclyAPIBlock>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      